import { render, staticRenderFns } from "./JobGrid.vue?vue&type=template&id=1903c3b8"
import script from "./JobGrid.vue?vue&type=script&lang=js"
export * from "./JobGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports